import type { FaireProductEntity } from "../../entity_types/product";

export const p_e7mrsvt2xu: FaireProductEntity = {
  token: "p_e7mrsvt2xu",
  type: "product",
  name: "Lined With Gold",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/0641ba5932ea01f15fd2c3b53f6968e1897f10c55bad0a5fdaa8b0bf77fafe4a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d559bc6c183ce59e18cc1dc66e413f4e613cef26a621d3ab92be1fdd001d9470.jpeg",
    "https://cdn.faire.com/fastly/d4ec61e47afd227d1d191a164e2c0b461a823743e6a9119d43611a2bd6af6c82.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:00:01.703Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
